import React, { Component } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { deepOrange, deepPurple } from '@material-ui/core/colors';

import CardCollapse from "../../components/Cards/CardCollapse";
import Wrapper from "../../components/Common/Wrapper";

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: '30px',
    },
    grid: {
        width: 1200,
        marginTop: 40,
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 20px)"
        }
    },
    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    purple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],
    },
});

class Faq extends Component {
    render() {
        const { classes } = this.props;
        const currentPath = this.props.location.pathname;

        return (
            <Wrapper currentPath={currentPath} footer={true} loaded={true}>
                <CardCollapse classes={classes} />
            </Wrapper>
        );
    }
}

export default withStyles(styles)(Faq);
